import { render } from "./Posts.vue?vue&type=template&id=3184ca24"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pooshakistanbul-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__